/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CheckRegResponseApiRoaming } from '../../models/check-reg-response-api-roaming';

export interface ApiRoamingCheckRegEmailGet$Params {

/**
 * email address to verify
 */
  email?: string;
}

export function apiRoamingCheckRegEmailGet(http: HttpClient, rootUrl: string, params?: ApiRoamingCheckRegEmailGet$Params, context?: HttpContext): Observable<StrictHttpResponse<CheckRegResponseApiRoaming>> {
  const rb = new RequestBuilder(rootUrl, apiRoamingCheckRegEmailGet.PATH, 'get');
  if (params) {
    rb.query('email', params.email, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CheckRegResponseApiRoaming>;
    })
  );
}

apiRoamingCheckRegEmailGet.PATH = '/api/Roaming/CheckRegEmail';
